/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface PackagesResubmitRequest {
    uuid: string;
}

/**
 * PackagesApi - interface
 * 
 * @export
 * @interface PackagesApiInterface
 */
export interface PackagesApiInterface {
    /**
     * Resubmit a stalled package.
     * @summary resubmit packages
     * @param {string} uuid Package UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApiInterface
     */
    packagesResubmitRaw(requestParameters: PackagesResubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Resubmit a stalled package.
     * resubmit packages
     */
    packagesResubmit(requestParameters: PackagesResubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PackagesApi extends runtime.BaseAPI implements PackagesApiInterface {

    /**
     * Resubmit a stalled package.
     * resubmit packages
     */
    async packagesResubmitRaw(requestParameters: PackagesResubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling packagesResubmit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/packages/{uuid}/resubmit`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resubmit a stalled package.
     * resubmit packages
     */
    async packagesResubmit(requestParameters: PackagesResubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.packagesResubmitRaw(requestParameters, initOverrides);
    }

}
